<template>
  <h1>Filters of customers</h1>
</template>

<script>
export default {};
</script>

<style>
</style>
